export const CONSTANT_VARIABLES = {
  ADMIN: 'admin',
  CUSTOMER: 'customer',
  DEVELOP: 'develop',
  PRODUCTION: 'production',
  STAGE: 'stage',
  USER_STORAGE_KEY: 'user',
  AGENT: 'agent',
  // NAT-2499 (phase 6, manual-testing gap) — the user detail view's plural
  // "every venue held" field. Replaces a singular CLIENT key: `IUserDetails`
  // only ever emits `clients` now, never `client` (confirmed by repo-wide
  // grep before removing CLIENT — nothing else referenced it).
  CLIENTS: 'clients',
  AUDITOR: 'auditor',
  // NAT-2788 — the Natives Coffee role (code 5): one page, and admins see it too.
  COFFEE: 'coffee',
};

/** The numeric role codes the backend stores and `/utils/user-roles` returns. */
export const USER_ROLE = {
  CUSTOMER: 0,
  ADMIN: 1,
  AGENT: 3,
  AUDITOR: 4,
  // NAT-2788
  COFFEE: 5,
} as const;

export const SHIPPING_COST = 20;

export const NATIVES_CLIENT_ID = 13;

// NAT-2499 adversarial review round 4, finding 4 — the client identity the server restricts
// Admin-role users to ("Restrict Admin role to Xpitality Srl", `ERR_NATIVES_ADMIN_ONLY`).
// Confirmed against the database: id 13 / slug 'natives' / name 'Natives'. A prior
// `XPITALITY_CRED` constant carried the OLD, drifted display name ('Xpitality Srl', which
// matches no real client) and was removed in NAT-2531 once its last caller switched to this
// slug — don't reintroduce a name-based Xpitality check.
export const NATIVES_CLIENT_SLUG = 'natives';
